import { FlexBox, IconButton, InputText } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { KeyboardEvent, useState } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

import styles from './topBarSearchField.module.scss';

type TopBarSearchFieldProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const TopBarSearchField = ({
  isOpen,
  onOpenChange,
}: TopBarSearchFieldProps): JSX.Element | null => {
  const [value, setValue] = useState('');
  const navigate = useAppNavigate();

  const handleOnSubmit = () => {
    if (value) {
      ampli.searchFieldSubmitted({
        location: 'topbar',
        isEmpty: false,
        query: value,
      });

      navigate({
        path: '/search/:tab',
        params: {
          path: { tab: 'conversations' },
          search: { q: value },
        },
      });

      onOpenChange?.(!isOpen);
    }
  };

  const resetSearchField = () => {
    setValue('');
    onOpenChange?.(false);
  };

  const handleOnKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleOnSubmit();
    }

    if (event.key === 'Escape') {
      resetSearchField();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <InputText
      className={styles.root}
      type="search"
      autoFocus
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Search..."
      onFocus={() => ampli.searchFieldFocused({ location: 'topbar' })}
      onBlur={() => {
        ampli.searchFieldBlurred({ location: 'topbar' });
        resetSearchField();
      }}
      onKeyDown={(e) => handleOnKeyDown(e)}
      data-testid="top-bar-search-input-field"
      suffix={{
        type: 'custom',
        value: (
          <FlexBox alignItems="center" padding="0 100" gap="100">
            <IconButton
              className={styles.inputButton}
              variant="tertiary"
              size="normal"
              icon={'close'}
              onClick={() => {
                setValue('');
                onOpenChange?.(!isOpen);
              }}
            />
          </FlexBox>
        ),
        noWrap: true,
      }}
    />
  );
};
